// extracted by mini-css-extract-plugin
export var actions = "_4q-0";
export var actionsContainer = "_4q-7";
export var border = "_4q-1";
export var childFullHeight = "_4q-f";
export var collapse = "_4q-2";
export var content = "_4q-a";
export var contentChild = "_4q-e";
export var fullscreen = "_4q-c";
export var hasLeftRadius = "_4q-k";
export var headerContainer = "_4q-3";
export var headerRow = "_4q-5";
export var hidePadding = "_4q-b";
export var navCollapsedGap = "_4q-l";
export var noScrollX = "_4q-m";
export var noScrollY = "_4q-n";
export var noTopPadding = "_4q-i";
export var optOutTopPadding = "_4q-d";
export var pageMain = "_4q-j";
export var pageOuter = "_4q-g";
export var pagePadding = "_4q-8";
export var pageScroll = "_4q-9";
export var profile = "_4q-o";
export var profileContainer = "_4q-p";
export var profileImage = "_4q-q";
export var profileMain = "_4q-r";
export var profileSubtitle = "_4q-t";
export var profileTitle = "_4q-s";
export var showLeftPadding = "_4q-h";
export var tabsPortalSlot = "_4q-6";
export var tabsWrapper = "_4q-4";
export var title = "_4q-u";